/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_COMPLIANCE_LIST (state, val) {
    state.complianceList = val
  },
  UPDATE_COMPLIANCE_LIST (state, val) {
    state.complianceList.push(...val)
  },
  UPDATE_COMPLIANCE (state, compliance) {        
    const i = state.complianceList.findIndex((i) => i.id === compliance.id)
    Object.assign(state.complianceList[i], compliance)
  },
  DELETE_COMPLIANCE (state, compliance) {
    const i = state.complianceList.findIndex((i) => i.id == compliance.id)
    state.complianceList.splice(i, 1)
  },
  ADD_COMPLIANCE (state, compliance) {
    state.complianceList.unshift(compliance)
  },
  CLEAR_COMPLIANCE_LIST(state){
    state.complianceList={}
  },
  SET_VENDOR_LIST(state,val){
    state.vendors = val
  },
  ADD_VENDOR(state,vendor){
    state.vendors.unshift(vendor)
  }
  
}
